module.exports = __webpack_public_path__ + "img/foove-platform-logo.c1c91be7.svg";